// extracted by mini-css-extract-plugin
export default {"youtubeVideoContainer":"_29HPKitod5m0yq7zF3MLSJ"};